/**
 * JoinCodeDisplay Component
 *
 * Large, prominent display of the 4-letter join code for participants.
 */

import styles from './Race.module.css';

interface JoinCodeDisplayProps {
  code: string;
}

export function JoinCodeDisplay({ code }: JoinCodeDisplayProps) {
  return (
    <div className={styles.joinCodeContainer}>
      <span className={styles.joinCodeLabel}>Join Code</span>
      <div className={styles.joinCode}>{code}</div>
      <p className={styles.joinCodeHint}>
        Students enter this code in the TOKO app to join
      </p>
    </div>
  );
}
